import React from 'react';

const AboutUs = () => {
    return (
        <section id="about">
            <div className="container">
                <header className="section-header">
                    <h3>About Us</h3>
                    <p>
                        Shri Lalitha Equipments was established in the year 2004 in Central India and has grown exponentially over the past several years. We offer our machines on rent for various projects all over India. We consistently strive to provide our clients with affordable and efficient rental service along with reliable equipment. Our team works flexibly to get our clients’ work done in a timely manner and delivers full customer satisfaction. We have provided our services to various projects such as power plants, cement plants, collieries, metro projects, bridge constructions, stadium constructions, pre-cast/iron gutter erections and steel plants. Our growing clientele is a testament to the quality of service provided by us.
                    </p>
                </header>
            </div>
        </section>
    );
}

export default AboutUs;